import { render } from "./InitialUwRecentNotesCard.vue?vue&type=template&id=0113df38&scoped=true"
import script from "./InitialUwRecentNotesCard.vue?vue&type=script&lang=js"
export * from "./InitialUwRecentNotesCard.vue?vue&type=script&lang=js"

import "./InitialUwRecentNotesCard.vue?vue&type=style&index=0&id=0113df38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0113df38"]])

export default __exports__